"use client";

// ============================================================
// ANSICHTSSACHE-AGENT – Live: Browserzustand, der dem Server folgt
// ============================================================
// `router.refresh()` reicht neue Props herein — aber ein Bauteil,
// das seine Props einmal in `useState` kopiert hat, zeigt weiter die
// Kopie. So standen am 26.09.2026 rund zwanzig Ansichten still:
// Leistungskatalog, Voreinstellungen, Urlaubstage, Arbeitszeitmodelle,
// die Notiz am Beleg, der Leistungszeitraum, die Schalter einer
// Freigabe … Live kam an, gezeigt wurde es nicht.
//
// Dieser Haken ist `useState` mit Rueckweg: aendert sich der Stand
// vom Server, uebernimmt er ihn — beim Zeichnen, nicht in einem
// Effekt, der einen Bildaufbau lang noch das Alte zeigt (dasselbe
// Muster wie `useServerValue` in `ui/inline-edit.tsx`).
//
// Zwei Kanten, ohne die er mehr kaputt macht als heilt:
//
// - VERGLICHEN WIRD DER INHALT, nicht der Verweis. Jede Auffrischung
//   liefert neue Objekte und Listen, auch wenn sich nichts geaendert
//   hat. Mit `!==` ueberschriebe jede Aenderung IRGENDWO im Haus die
//   Eingabe, die hier gerade entsteht.
// - `hold`: solange jemand hier schreibt (Fokus im Feld, ungesicherte
//   Aenderung, offener Bearbeitungsmodus), bleibt die Eingabe stehen.
//   Der neue Stand wartet und wird uebernommen, sobald `hold` faellt —
//   bis dahin gewinnt, wer tippt.
// ============================================================

import { useState, type Dispatch, type SetStateAction } from "react";

/** Inhaltlicher Vergleich — `bigint` kann JSON nicht von sich aus. */
function signatureOf(value: unknown): string {
  return JSON.stringify(value, (_key, v: unknown) => (typeof v === "bigint" ? `${v}n` : v)) ?? "";
}

export function useServerState<T>(serverValue: T, hold = false): [T, Dispatch<SetStateAction<T>>] {
  const signature = signatureOf(serverValue);
  const [state, setState] = useState(serverValue);
  const [seen, setSeen] = useState(signature);

  if (seen !== signature && !hold) {
    setSeen(signature);
    setState(serverValue);
  }

  return [state, setState];
}
